import Vue from 'vue'
import moment from "moment";
import accounting from "accounting";
import VuetableFieldSequence from 'vuetable-2/src/components/VuetableFieldSequence.vue'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
Vue.component('vuetable-field-checkbox', VuetableFieldCheckbox)

export default [

  // {
  //   name: 'vuetable-field-checkbox',
  //   title: "checkbox",
  //   width: "5%"
  // },
  {
    name: "documentType",
    title: 'Document Type',
    width: "90%",
    sortField: "documentType.id",
    formatter(value) {
      return value.type;
    }
  },
  {
    name: "custom-filename",
    title: "File Name",
    width: "90%"
  },
  {
    name: "custom-actions",
    title: "Actions",
    width: "10%"
  }
]